import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('foquz-dialog-header', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('foquz-dialog__header');

      return new ViewModel(params, element);
    },
  },
  template: html,
});
